import React from 'react';
import { InputGroup, Form, Button, Row, Col } from 'react-bootstrap';

const DateRangeInput = ({ startDate, endDate, setStartDate, setEndDate, handleGenerate, loading }) => (
  <div className="d-flex justify-content-center align-items-center mb-3">
    <Row className="align-items-center">
      {/* Input Section */}
      <Col xs={12} sm={4} className="mb-3 mb-sm-0">
        <InputGroup>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="date-picker"
          />
        </InputGroup>
      </Col>
      
      <Col xs={12} sm={1} className="text-center">
        <span>TO</span>
      </Col>
      
      <Col xs={12} sm={4} className="mb-3 mb-sm-0">
        <InputGroup>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="date-picker"
          />
        </InputGroup>
      </Col>

      {/* Generate Button */}
      <Col xs={12} sm={3} className="text-center">
        <Button
          variant="primary"
          onClick={handleGenerate}
          disabled={loading}
          className="w-100"
        >
          {loading ? 'Generating...' : 'Generate'}
        </Button>
      </Col>
    </Row>
  </div>
);

export default DateRangeInput;
